import { render, staticRenderFns } from "./CenterData.vue?vue&type=template&id=35be7039&scoped=true"
import script from "./CenterData.vue?vue&type=script&lang=js"
export * from "./CenterData.vue?vue&type=script&lang=js"
import style0 from "./CenterData.vue?vue&type=style&index=0&id=35be7039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be7039",
  null
  
)

export default component.exports